import { directories } from "@/mocks/home";

export default function Directory() {
  return (
    <section id="directory" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">CATEGORY INDEX</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              看料目录
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按主题把条目归档，想找哪一类就直接进目录，比翻列表更快。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-xs text-foreground-600 md:self-auto">
            <i className="ri-database-2-line text-sm text-secondary-600" />
            共 8 个目录 · 637 条
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {directories.map((dir, idx) => (
            <a
              key={dir.name}
              href="#roundup"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/60 cursor-pointer animate-fade-up"
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${dir.icon} text-xl`} />
              </span>
              <div className="mt-4 flex items-baseline justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {dir.name}
                </h3>
                <span className="font-heading text-sm font-bold text-accent-600">{dir.count}</span>
              </div>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{dir.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-foreground-500 group-hover:text-primary-600">
                进入目录
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}